import React, { Component } from "react";
import { IStore } from "@my-dld/reducers/store";
import { connect } from "react-redux";
import { defaultState, EjariDataAction, EjariDataState, EjariUserType } from "../reducers/EjariData";
import PropertyLoader, { EjariCtxPropertyLoader } from "@eres/ejari-core/loaders/PropertyLoader";
import { getEjariActiveUserId } from "@10x/sso";
import { dispatchX } from "@my-dld/utils/StoreUtils";
import { hideLoading, showLoading } from "@my-dld/utils/UIUtils";


export interface IEjariContext extends EjariDataState {

}


interface Props extends IEjariContext {
	extraContext?: Partial<EjariDataState>;
	loader?: EjariCtxPropertyLoader;
}

export const EjariContext = React.createContext( defaultState );

interface State {
}

class EjariContextWrapper extends Component<Props, State> {
	static defaultProps: Partial<Props> = {
		loader: PropertyLoader,
	};

	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: true
		};
		if ( this.props.extraContext ) {
			dispatchX( {
				type: EjariDataAction.EJARI_UPDATE_STATE,
				payload: { ...this.props.extraContext }
			} );
		}
	}

	componentDidMount() {
		let ejariActiveUserId = getEjariActiveUserId();
		let payload: Partial<EjariDataState> = {
			activeUserId: ejariActiveUserId,
		};
		dispatchX( {
			type: EjariDataAction.EJARI_UPDATE_STATE,
			payload: payload
		} );
	}

	componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any ) {
		if ( prevProps.isRefreshing != this.props.isRefreshing ) {
			if ( this.props.isRefreshing )
				showLoading();
			else hideLoading();
		}
	}

	render() {
		const { children, extraContext, loader, ...props } = this.props;
		const Loader = loader!;
		return <EjariContext.Provider value={ props }>
			<Loader>
				{ children }
			</Loader>
		</EjariContext.Provider>;
	}
}

const mapStateToProps = ( state: IStore, ownProps: Partial<IEjariContext> & { children?: any } ): IEjariContext => {
	return {
		...state.EjariData,
	};
};


export default connect( mapStateToProps )( EjariContextWrapper );

export function switchEjariUserMode( userType: EjariUserType ) {
	dispatchX( {
		type: EjariDataAction.EJARI_UPDATE_STATE,
		payload: {
			userType: userType,
		}
	} );
}

export function updateEjariContext( data: Partial<EjariDataState> ) {
	dispatchX( {
		type: EjariDataAction.EJARI_UPDATE_STATE,
		payload: {
			...data
		}
	} );
}

